import { get } from 'api';

export const getBuildLogs = (repository: string, timestamp: string, owner: string) =>
  get({
    url: `${owner}/build/${repository}/${timestamp}/logs`,
  });
